export default __webpack_public_path__ + "static/media/AddContactAvatar.b6bb1903.png";